import { codeableConcept } from '#src/codeableConcept.ts'

// https://loinc.org/11492-6
export const PROVIDER_UNSPECIFIED_HISTORY_AND_PHYSICAL_NOTE_CODING =
  codeableConcept({
    system: 'http://loinc.org',
    code: '11492-6',
    display: '',
  })

// https://loinc.org/29762-2
export const SOCIAL_HISTORY_NARRATIVE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '29762-2',
  display: 'Social History Narrative',
})

// https://loinc.org/10164-2
export const HISTORY_OF_PRESENT_ILLNESS_NARRATIVE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '10164-2',
  display: 'History of Present illness Narrative',
})

// https://loinc.org/47420-5
export const FUNCTIONAL_STATUS_ASSESSMENT_NOTE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '47420-5',
  display: 'Functional status assessment note',
})

// https://loinc.org/18776-5
export const PLAN_OF_CARE_NOTE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '18776-5',
  display: 'Plan of care note',
})

// https://loinc.org/34133-9
export const ADMISSION_HISTORY_AND_PHYSICAL_NOTE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '34133-9',
  display: 'Admission history and physical note',
})

// https://loinc.org/11369-6
export const DISCHARGE_SUMMARY_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '11369-6',
  display: 'Discharge summary',
})

// https://loinc.org/28570-0
export const PROCEDURE_NOTE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '28570-0',
  display: 'Procedure note',
})

// https://loinc.org/38208-5
export const PAIN_SEVERITY_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '38208-5',
  display: 'Pain severity',
})
export const PAIN_SEVERITY_SCALE_TYPE = 'Ord'
export const PAIN_SEVERITY_UNIT = null
export const PAIN_SEVERITY_ANSWER_OPTIONS = [
  {
    code: 'LA19102-5',
    display: '0 - No pain',
  },
  {
    code: 'LA6112-2',
    display: '1',
  },
  {
    code: 'LA6113-0',
    display: '2 or more',
  },
  {
    code: 'LA6114-8',
    display: '3',
  },
  {
    code: 'LA6115-5',
    display: '4',
  },
  {
    code: 'LA10137-0',
    display: '5',
  },
  {
    code: 'LA10138-8',
    display: '6',
  },
  {
    code: 'LA10139-6',
    display: '7',
  },
  {
    code: 'LA10140-4',
    display: '8',
  },
  {
    code: 'LA10141-2',
    display: '9',
  },
  {
    code: 'LA21948-7',
    display: '10 - worst imaginable pain',
  },
]

// https://loinc.org/8302-2
export const BODY_HEIGHT_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '8302-2',
  display: 'Body height',
})
export const BODY_HEIGHT_SCALE_TYPE = 'Qn'
export const BODY_HEIGHT_UNIT = '[in_us]'

// https://loinc.org/29463-7
export const BODY_WEIGHT_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '29463-7',
  display: 'Body weight',
})
export const BODY_WEIGHT_SCALE_TYPE = 'Qn'
export const BODY_WEIGHT_UNIT = '[lb_av]'

// https://loinc.org/20564-1
export const OXYGEN_SATURATION_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '20564-1',
  display: 'Oxygen saturation in Arterial blood',
})
export const OXYGEN_SATURATION_SCALE_TYPE = 'Qn'
export const OXYGEN_SATURATION_UNIT = '%'

// https://loinc.org/9279-1
export const RESPIRATORY_RATE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '9279-1',
  display: 'Respiratory rate',
})
export const RESPIRATORY_RATE_SCALE_TYPE = 'Qn'
export const RESPIRATORY_RATE_UNIT = '{breaths}/min'

// https://loinc.org/8867-4
export const HEART_RATE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '8867-4',
  display: 'Heart rate',
})
export const HEART_RATE_SCALE_TYPE = 'Qn'
export const HEART_RATE_UNIT = '{beats}/min'

// https://loinc.org/8287-5
export const HEAD_CIRCUMFERENCE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '8287-5',
  display: 'Head circumference',
})

// https://loinc.org/8310-5
export const BODY_TEMPERATURE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '8310-5',
  display: 'Body temperature',
})
export const BODY_TEMPERATURE_SCALE_TYPE = 'Qn'
export const BODY_TEMPERATURE_UNIT = '[degF]'

// https://loinc.org/85354-9
export const BLOOD_PRESSURE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '85354-9',
  display: 'Blood pressure systolic & diastolic',
})
export const BLOOD_PRESSURE_SCALE_TYPE = 'Qn'
export const BLOOD_PRESSURE_UNIT = null

// https://loinc.org/8480-6
export const SYSTOLIC_BLOOD_PRESSURE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '8480-6',
  display: 'Systolic blood pressure',
})

// https://loinc.org/8462-4
export const DIASTOLIC_BLOOD_PRESSURE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '8462-4',
  display: 'Diastolic blood pressure',
})

// https://loinc.org/39156-5
export const BODY_MASS_INDEX_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '39156-5',
  display: 'Body mass index',
})
export const BODY_MASS_INDEX_SCALE_TYPE = 'Qn'
export const BODY_MASS_INDEX_UNIT = 'kg/m2'

// https://loinc.org/59576-9
export const BODY_MASS_INDEX_PERCENTILE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '59576-9',
  display: 'Body mass index percentile',
})

// https://loinc.org/3016-3
export const TSH_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '3016-3',
  display: 'TSH',
})

// https://loinc.org/718-7
export const HEMOGLOBIN_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '718-7',
  display: 'Hemoglobin',
})

// https://loinc.org/5195-3
export const RPR_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '5195-3',
  display: 'RPR',
})

// https://loinc.org/2132-9
export const VITAMIN_B12_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: '2132-9',
  display: 'Vitamin B12',
})

export interface LabOption {
  coding: ReturnType<typeof codeableConcept>
  display: string
  abbreviation?: string
}

export const LAB_OPTIONS: LabOption[] = [
  { coding: TSH_CODING, display: 'TSH' },
  { coding: HEMOGLOBIN_CODING, display: 'Hemoglobin', abbreviation: 'Hgb' },
  { coding: RPR_CODING, display: 'RPR' },
  { coding: VITAMIN_B12_CODING, display: 'Vitamin B12', abbreviation: 'B12' },
]

export const LoincCode = {
  VACCINES_DUE_NEXT: '30979-9',
  DATE_VACCINE_DUE: '30980-7',
  EARLIEST_ADMINISTRATION_DATE: '30981-5',
  DOSE_NUMBER_IN_SERIES: '30973-2',
  REASON_APPLIED_BY_FORECAST: '30982-3',
  DATE_WHEN_OVERDUE: '59778-1',
  IMMUNIZATION_FORECAST_STATUS: '59783-1',
  NUMBER_OF_DOSES_IN_PRIMARY_SERIES: '59782-3',
  DOSE_VALIDITY: '59781-5',
  REACTION: '31044-1',
  VACCINE_FUNDING_PROGRAM_ELIGIBILITY: '64994-7',
  VACCINE_FUNDING_SOURCE: '30963-3',
  COMPONENT_VACCINE_TYPE: '38890-0',
} as const
export type LoincCode = (typeof LoincCode)[keyof typeof LoincCode]

export const VACCINES_DUE_NEXT_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.VACCINES_DUE_NEXT,
  display: 'Vaccines due next',
})

export const DATE_VACCINE_DUE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.DATE_VACCINE_DUE,
  display: 'Date vaccine due',
})

export const EARLIEST_ADMINISTRATION_DATE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.EARLIEST_ADMINISTRATION_DATE,
  display: 'Earliest date to give',
})

export const DOSE_NUMBER_IN_SERIES_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.DOSE_NUMBER_IN_SERIES,
  display: 'Dose number in series',
})

export const REASON_APPLIED_BY_FORECAST_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.REASON_APPLIED_BY_FORECAST,
  display: 'Reason applied by forecast logic',
})

export const DATE_WHEN_OVERDUE_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.DATE_WHEN_OVERDUE,
  display: 'Date when overdue',
})

export const IMMUNIZATION_FORECAST_STATUS_CODING = codeableConcept({
  system: 'http://loinc.org',
  code: LoincCode.IMMUNIZATION_FORECAST_STATUS,
  display: 'Immunization forecast status',
})
